/**
 * Post-login redirect based on profile scope and role.
 */
export function homePathForProfile(profile) {
  if (!profile) return '/';
  if (profile.super_admin) return '/super-admin';
  if (profile.profile_scope === 'marketplace') {
    if (profile.marketplace_admin) return '/marketplace/admin';
    if (profile.role === 'driver') {
      if (profile.marketplace_driver_status === 'approved') return '/marketplace/driver';
      return '/marketplace/driver/apply';
    }
    return '/marketplace/passenger';
  }
  if (profile.role === 'admin') return '/admin';
  if (profile.role === 'driver') {
    if (profile.approval_status === 'pending' || profile.approval_status === 'rejected') {
      return '/driver/pending';
    }
    return '/driver';
  }
  return '/passenger';
}
